import { useQuery } from "@tanstack/react-query";
import { fetchAllPackages } from "../repositories/package.repository";

export const usePackages = () => {
  return useQuery({
    queryKey: ["packages"],
    queryFn: fetchAllPackages,
  });
};
